import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EnfermedadCatastroficaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EnfermedadCatastroficaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEnfermedadCatastroficaService(): Observable<BodyListResponse<EnfermedadCatastroficaDTO>> {
    return this.http.get<BodyListResponse<EnfermedadCatastroficaDTO>>(API_URL + '/api/v1/enfermedadCatastrofica/todos');
  }

  guardarEnfermedadCatastroficaService(enfermedadCatastroficaDTO: EnfermedadCatastroficaDTO): Observable<EnfermedadCatastroficaDTO> {
    return this.http.post<EnfermedadCatastroficaDTO>(API_URL + '/api/v1/enfermedadCatastrofica', enfermedadCatastroficaDTO);
  }

  getEnfermedadCatastroficaPorCodigoEnfermedadCatastroficaService(codigoEnfermedadCatastrofica: string): Observable<BodyResponse<EnfermedadCatastroficaDTO>> {
    return this.http.get<BodyResponse<EnfermedadCatastroficaDTO>>(API_URL + '/api/v1/enfermedadCatastrofica/' + codigoEnfermedadCatastrofica);
  }

  getEnfermedadCatastroficaPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EnfermedadCatastroficaDTO>> {
    return this.http.get<BodyListResponse<EnfermedadCatastroficaDTO>>(API_URL + '/api/v1/enfermedadCatastrofica/persona/' + codigoPersona);
  }

}
